import { handleResponse } from '../Helpers/handle-response';

export const apiDataService = {
    getApis,
    deleteApi,
    editRow,
    addRow
};

function getApis() {
    const requestOptions = { method: 'GET' };
    return fetch(process.env.REACT_APP_APIURL + 'apiscopes', requestOptions).then(handleResponse);
}

function deleteApi(id) {
    const requestOptions = { method: 'DELETE' };
    console.log(process.env.REACT_APP_APIURL + 'apiscopes/?id=' + id, requestOptions)
    return fetch(process.env.REACT_APP_APIURL + 'apiscopes/' + id, requestOptions).then(handleResponse);
}

function editRow(row) {
    const requestOptions = { method: 'PUT', headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    }, body: JSON.stringify(row) };
    return fetch(process.env.REACT_APP_APIURL + 'apiscopes', requestOptions).then(handleResponse);
}

function addRow(row) {
    console.log('add', row)
    const requestOptions = { method: 'POST', headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    }, body: JSON.stringify(row) };
    return fetch(process.env.REACT_APP_APIURL + 'apiscopes', requestOptions).then(handleResponse);
}